import type {
  OrderListStatus,
  OrderPaymentState,
  OrderStatus,
  PaymentMethod,
} from "@/types";

export const ORDER_API_ENDPOINTS = {
  LIST: "/orders",
  CHECKOUT: "/order/checkout",
  CHECKOUT_STATUS: (orderId: string) =>
    `/order/checkout/order-status/${orderId}`,
  DETAIL: (orderId: string) => `/orders/${orderId}`,
  CANCEL: (orderId: string) => `/orders/${orderId}/cancel`,
  TRACK: (orderId: string) => `/orders/${orderId}/track`,
  SHIPPING_CALCULATE: "/orders/shipping-calculate",
  APPLY_VOUCHER: "/orders/vouchers/apply",
  CHECKOUT_BOOTSTRAP: "/orders/checkout/bootstrap",
  PAYMENT_METHODS: "/payment/methods",
} as const;

export const ORDER_MOCK_DELAYS = {
  bootstrap: 320,
  shipping: 260,
  voucher: 260,
  createOrder: 680,
  checkoutStatus: 220,
  getOrders: 240,
  updateOrder: 320,
} as const;

export const CHECKOUT_TRANSFER_POLL_INTERVAL_MS = 10_000;
export const CHECKOUT_TRANSFER_TIMEOUT_MS = 15 * 60 * 1000;
export const CHECKOUT_TRANSFER_MOCK_AUTO_PAY_MS = 20_000;

export const PAYMENT_METHOD_LABELS: Record<PaymentMethod, string> = {
  cod: "Thanh toán khi nhận hàng",
  bank_transfer: "Chuyển khoản ngân hàng",
};

export const ORDER_PAYMENT_STATE_LABELS: Record<OrderPaymentState, string> = {
  pending: "Chờ thanh toán",
  paid: "Đã thanh toán",
  unpaid: "Chưa thanh toán",
  failed: "Thanh toán thất bại",
  expired: "Hết hạn thanh toán",
};

export const ORDER_STATUS_LABELS: Record<OrderStatus, string> = {
  pending: "Chờ xác nhận",
  processing: "Đang xử lý",
  shipped: "Đang giao",
  delivered: "Đã giao",
  cancelled: "Đã hủy",
};

export const ORDER_LIST_TABS: Array<{
  key: OrderListStatus;
  label: string;
}> = [
  { key: "all", label: "Tất cả" },
  { key: "pending", label: ORDER_STATUS_LABELS.pending },
  { key: "processing", label: ORDER_STATUS_LABELS.processing },
  { key: "shipped", label: ORDER_STATUS_LABELS.shipped },
  { key: "delivered", label: ORDER_STATUS_LABELS.delivered },
  { key: "cancelled", label: ORDER_STATUS_LABELS.cancelled },
];
